<template>

    <m-edit1/>

    <m-offer-archive-1 v-bind='{...{},...{}}' :style='""' class="" ></m-offer-archive-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mOfferArchive1 from '@moeinmdn/miw-alpha-components/src/package/Dashboard/Offer/Archive/OfferArchive1';

export default {
    name: 'HomeView',
    components: {mEdit1, mOfferArchive1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
